import { Column, Entity, Unique } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('client_location_count_state')
@Unique('uq_client_loc_count_state', ['state'])
export class ClientLocationCountStateEntity extends BaseEntity {
	@Column('varchar', { name: 'state', length: 10 })
	public state!: string;

	@Column('int', { name: 'client_count', unsigned: true, default: 0 })
	public clientCount!: number;
}
